import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { Box, Button } from '@mui/material';
import DetailTemplate from '../../common/template/DetailTemplate';
import { useDispatch, useSelector } from 'react-redux';
import OrderSheetModalContainer from '../../../containers/projectmng/order_sheet_sent/OrderSheetModalContainer';
import OrderSheetListContainer from '../../../containers/projectmng/order_sheet_sent/OrderSheetListContainer';

const OrderSheetSentTemplate = () => {
  const dispatch = useDispatch();
  const { project, originalCosts } = useSelector(({ projectModule }) => ({
    project: projectModule.project.project,
    originalCosts: projectModule.projectCosts.costs,
  }));

  const [costs, setCosts] = useState([]);

  //(주)에이치씨인포 제외
  useEffect(() => {
    if (originalCosts) {
      const filtered = originalCosts.filter(
        (cost) => cost.sellPartnerNm !== '(주)에이치씨인포',
      );
      setCosts(filtered);
    }
  }, [originalCosts]);

  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setData(null);
  };
  const handleSelectedSheet = (params) => {
    setData(params);
    setOpen(true);
  };

  return (
    <Box>
      <DetailTemplate title="보낸 발주서">
        <OrderSheetListContainer
          project={project}
          onRowClick={handleSelectedSheet}
        />
      </DetailTemplate>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Button
          variant="outlined"
          color="success"
          onClick={handleOpen}
          sx={{ mr: 1 }}
        >
          발주서 작성
        </Button>
      </Box>
      <OrderSheetModalContainer
        project={project}
        costs={costs}
        type={data != null ? 'edit' : 'add'}
        selectedOrderSheet={data}
        open={open}
        onClose={handleClose}
      />
    </Box>
  );
};

export default OrderSheetSentTemplate;
